export default __webpack_public_path__ + "static/media/FoodNetwork.84f7265a.svg";